import { apiClient } from "@/lib/api";

export const createThread = (candidate_id, job_id, initial_message) =>
  apiClient.post("/messages/threads", { candidate_id, job_id, initial_message });

export const listThreads = () => apiClient.get("/messages/threads");

export const getThreadMessages = (thread_id) =>
  apiClient.get(`/messages/threads/${thread_id}`);

export const sendMessage = (thread_id, text) =>
  apiClient.post(`/messages/threads/${thread_id}/send`, { text });

export const unreadCount = () => apiClient.get("/messages/unread");
